export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;

    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    templateId: string;
    brandId: string;
    senderId: string;
    age17TemplateId: string;
    age17BrandId: string;
    age17SenderId: string;
    expireInDays: string;
    ConnectTo: string;
    card: string;
    menu: string;
    vector: string;
    headerLogo: string;
    headerLogoHero: string;
    firstBg: string;
    OutlinePlus: string;
    IconCross: string;
    IconArrow:string;
    IconOne:string;
    IconTwo:string;
    IconThree:string;
    IconFour:string;
    IconRight: string;
    Icon_Right_Check: string;
    iconPlus: string;
    error_page_icon:string;
    bgPattern1: string;
    bgPattern2: string;
    bgPatternMobile: string;
    bgPatternMb1: string;
    bgPatternMb2: string;
    PatternBgMobile: string;
    landingPageHeaderArrow: string;
    bodyImage: string;
    chevronImage: string;
    centerLogo: string;
    centerBGImage: string;
    plusVector: string;
    footerLogo: string;
    unsuccessful: string;
    body: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    governmentSponsoredProgramId: string;
    uninsuredProgramId: string;
    surveyId: string;
    eligibilityPurchasePrescriptionQuestionId: string;
    eligibilityPurchasePrescriptionAnswerIdCommercial: string;
    eligibilityPurchasePrescriptionAnswerIdGovernment: string;
    eligibilityPurchasePrescriptionAnswerIdNoPrescription: string;
    eligibilityUSCitizenQuestionId: string;
    eligibilityUSCitizenAnswerIdYes: string;
    eligibilityUSCitizenAnswerIdNo: string;
    eligibilityMedicare: string;
    eligibilityMedicareAnswerYes: string;
    eligibilityMedicareAnswerNo: string;
    eligibilityCoverage: string;
    eligibilityCoverageAnswerYes: string;
    eligibilityCoverageAnswerNo: string;
    checkboxYouUnderstandQuestion: string;
    checkboxYouUnderstandAnswerYes: string;
    checkboxIUnderstandQuestion: string;
    checkboxThirdUnderstandQuestion: string;
    checkboxThirdUnderstandAnswerYes: string;
    checkboxIUnderstandAnswerYes: string;
    doesAgreeTextMessageQuestion: string;
    doesAgreeTextMessageAnswer: string;
    legalGuardianConfirmationQuestion: string;
    legalGuardianConfirmationAnswer: string;
    insuranceAddressOneQuestionId: string;
    insuranceAddressOneAnswerId: string;
    insuranceAddressTwoQuestionId: string;
    insuranceAddressTwoAnswerId: string;
    insuranceCityQuestionId: string;
    insuranceCityAnswerId: string;
    insuranceStateQuestionId: string;
    insuranceStateAnswerId: string;
    insuranceZipQuestionId: string;
    insuranceZipAnswerId: string;
    insuranceFaxNumberQuestionId: string;
    insuranceFaxNumberAnswerId: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    docusignPDF: string;
    shouldShowSplashPage: string;
    dataDomainScript: string;
    privacyIcon: string;
    insuranceCoPayQuestionId: string;
    insuranceCoPayAnswerId: string;
    legalGuardianDobQuestion: string; 
    legalGuardianDobAnswer: string; 
    legalGuardianGenderQuestion: string; 
    legalGuardianGenderAnswer: string; 
    legalGuardianAddressLineOneQuestion: string; 
    legalGuardianAddressLineOneAnswer: string; 
    legalGuardianAddressLineTwoQuestion: string; 
    legalGuardianAddressLineTwoAnswer: string; 
    legalGuardianCityQuestion: string; 
    legalGuardianCityAnswer: string; 
    legalGuardianStateQuestion: string; 
    legalGuardianStateAnswer: string; 
    legalGuardianZipQuestion: string; 
    legalGuardianZipAnswer: string; 
}
